import ProfileAnalytics from "./profile-analytics";

export default ProfileAnalytics;
